export const createRelationsQueryParamString = (
  relations: string[],
): string => {
  let result = '';
  for (const relation of relations) {
    result = result + '&relations[]=' + relation;
  }
  return result;
};
